<div class="container mt-4">
  <div class="row justify-content-center">
    <div class="col-md-8">
      <div class="card shadow-lg">
        <div class="card-body">
          <div class="back-button-section">
            <button class="back-button" (click)="goBack()"><i class="fa fa-arrow-left" aria-hidden="true"></i>
              Back</button>
          </div>
          <div class="position-relative">
            <!-- Logo -->
            <div class="logo-container">
              <img loading="lazy" src="assets/images/new-logo.png" alt="Logo" class="logo" />
            </div>
          </div>

          <h2 class="text-center mb-4" style="color: var(--primary)">Join as a Business / Home User</h2>
          <form [formGroup]="businessForm" (ngSubmit)="onSubmit()">
            <!-- option -->
            <div class="mb-4">
              <label for="companyName" class="form-label fw-bold">Type</label><br />
              <div class="d-flex"><input type="radio" name="option" class="mr-2" formControlName="type"
                  placeholder="Enter your company name" value="business" /> Business <input type="radio" name="option"
                  class="ml-2 mr-2" formControlName="type" placeholder="Enter your company name" value="home" /> Home
              </div>
            </div>

            <!-- Company Name -->
            <div class="mb-4">
              <label for="companyName" class="form-label fw-bold">Company Name</label>
              <input type="text" id="companyName" class="form-control rounded-pill" formControlName="companyName"
                placeholder="Enter your company name" />
              <div class="text-danger small mt-1"
                *ngIf="businessForm.get('companyName')?.invalid && businessForm.get('companyName')?.touched">Company
                name is required (minimum 3 characters).</div>
            </div>

            <!-- Contact -->
            <div class="mb-4">
              <label for="contact" class="form-label fw-bold">Contact</label>
              <input type="text" id="contact" class="form-control rounded-pill" formControlName="contact"
                placeholder="Enter your contact number" />
              <div class="text-danger small mt-1"
                *ngIf="businessForm.get('contact')?.invalid && businessForm.get('contact')?.touched">A valid 10-digit
                contact number is required.</div>
            </div>


            <!-- Short Description -->
            <div class="mb-3">
              <label for="shortDescription" class="form-label fw-bold">Short Description</label>
              <textarea id="shortDescription" class="form-control rounded-3" formControlName="shortDescription"
                placeholder="Enter a short description (max 200 characters)" rows="3"></textarea>
              <div class="text-danger small mt-1"
                *ngIf="businessForm.get('shortDescription')?.invalid && businessForm.get('shortDescription')?.touched">A
                short description is required (max 200 characters).</div>
            </div>

            <div id="changeLogAccordion" class="mb-3">
              <div class="card">
                <div class="card-header" id="heading2">
                  <h2 class="mb-0">
                    <button class="btn btn-link d-flex justify-content-between align-items-center collapsed"
                      type="button" data-toggle="collapse" data-target="#collapse2" aria-expanded="false"
                      aria-controls="collapse2">
                      Other Forms
                    </button>
                  </h2>
                </div>
                <div id="collapse2" class="collapse" aria-labelledby="heading2" data-parent="#changeLogAccordion">
                  <div class="card-body">

                    <!-- Address -->
                    <div class="mb-4" *ngIf="businessForm.get('type').value == 'business'">
                      <label for="address" class="form-label fw-bold">Address</label>
                      <textarea id="address" class="form-control rounded-3" formControlName="address"
                        placeholder="Enter your address" rows="3"></textarea>
                      <div class="text-danger small mt-1"
                        *ngIf="businessForm.get('address')?.invalid && businessForm.get('address')?.touched">Address is
                        required.</div>
                    </div>

                    <!-- Postal Code -->
                    <div class="mb-4">
                      <label for="postalCode" class="form-label fw-bold">Postal Code</label>
                      <input type="text" id="postalCode" class="form-control rounded-pill"
                        (keyup)="filterSubregions($event.target.value)" formControlName="postalCode"
                        placeholder="Enter your postal code" />
                      <div class="text-danger small mt-1"
                        *ngIf="businessForm.get('postalCode')?.invalid && businessForm.get('postalCode')?.touched">A
                        valid
                        6-digit postal code is required.</div>
                    </div>

                    <div class="mb-4">
                      <label for="postalCode" class="form-label fw-bold">Region</label>
                      <input type="text" id="postalCode" class="form-control rounded-pill" [disabled]="true"
                        formControlName="region" />
                    </div>

                    <!-- Image Upload -->
                    <div class="mb-4">
                      <label for="image" class="form-label fw-bold">Upload Image</label>
                      <input type="file" id="image" class="form-control" (change)="onFileSelected($event)" #fileInput />
                      <div *ngIf="imagePreview" class="mt-3 text-center">
                        <p class="text-secondary small">Image Preview:</p>
                        <img loading="lazy" [src]="imagePreview" alt="Preview" class="img-thumbnail shadow-sm"
                          style="max-width: 150px" />
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <!-- Submit Button -->
            <button type="submit" class="btn btn-primary w-100 rounded-pill py-2"
              [disabled]="businessForm.invalid">Submit</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>